import { useEffect, useState } from "react";
import useReveal from "@/hooks/useReveal";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import FintechSection from "@/components/landing/FintechSection";
import BookOfTheMonth from "@/components/landing/BookOfTheMonth";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import GenesisClubModal, {
  useGenesisClubController,
} from "@/components/landing/GenesisClubModal";
import GenesisClubRibbon from "@/components/landing/GenesisClubRibbon";

const RIBBON_HEIGHT_PX = 76;

const Landing = () => {
  useReveal("[data-landing]");
  const gclub = useGenesisClubController();
  const [ribbonVisible, setRibbonVisible] = useState(true);

  // Deep-link: `?book=<slug>` arrivals (from /api/share/book/<slug>) auto-scroll
  // to the Book of the Month section after the page settles.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (!params.get("book")) return;
    const id = window.setTimeout(() => {
      const el = document.getElementById("book");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 600);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <div data-landing data-reveal-root className="relative">
      <GenesisClubRibbon
        onOpenModal={gclub.forceOpen}
        onVisibilityChange={setRibbonVisible}
      />
      <Nav topOffsetPx={ribbonVisible ? RIBBON_HEIGHT_PX : 0} />
      <main className="relative z-10">
        <Hero />
        <BookOfTheMonth />
        <Marquee />
        <FintechSection />
        <FAQ />
      </main>
      <Footer />
      <GenesisClubModal open={gclub.open} onClose={gclub.close} />
    </div>
  );
};

export default Landing;
